import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate } from "react-router-dom";
import { SignIn } from "../functions/authenticate";
import SpinnerLoader from "../components/spinnerLoader";
import bannerBgSVG from "../assets/media/banner_bg.svg";

export default function Login(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [userid, setUserId] = useState(null);
  const [password, setPassword] = useState(null);
  const [useridError, setUserIdError] = useState({ bool: false, value: "" });
  const [passwordErr, setPasswordError] = useState({ bool: false, value: "" });
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const onChangeTxt = async (event, func) => {
    let value = event.target.value;
    func(value);
  };

  const validateFields = async () => {
    if (password) {
      setPasswordError({ bool: false, value: "" });
    } else {
      setPasswordError({ bool: true, value: "Invalid Password" });
      return false;
    }
    if (!userid) {
      setUserIdError({ bool: true, value: "Invalid user id" });
      return false;
    } else {
      setUserIdError({ bool: false, value: "" });
    }
    return true;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoad(true);
    let validate = await validateFields();
    if (validate) {
      const signObj = await SignIn(password, userid, navigate);
      if (signObj) {
        setUserId(null);
        setPassword(null);
      }
    }
    setLoad(false);
  };

  return (
    <Grid container>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgLeftBg" sx={{backgroundImage: `url(${bannerBgSVG})`}}>
        <Grid className="logoDiv">
          <img src="media/logo.svg" className="logoImg" />
        </Grid>
        <Grid className="roboDiv">
          <img src="media/robot.svg" className="roboImg" />
        </Grid>
      </Grid>
      <Grid md={6} lg={6} sm={12} xs={12} className="lgcommonBg lgRightBg">
        <div className="insideCont customInside">
          <h1 className="lgTitle">Log In</h1>
          {load ? (
            <SpinnerLoader visible={load} />
          ) : (
            <form onSubmit={onSubmit} onDragEnter={onSubmit}>
              <TextField
                fullWidth
                error={useridError.bool}
                id="outlined-error-helper-text"
                label="User ID / Email"
                className="formtext"
                value={userid}
                onChange={(e) => {
                  onChangeTxt(e, setUserId);
                }}
                autoComplete={false}
                placeholder="kevin.hector@email.com"
                helperText={useridError.value}
              />
              <FormControl className="formtext" fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  fullWidth
                  error={passwordErr.bool}
                  value={password}
                  onChange={(e) => {
                    onChangeTxt(e, setPassword);
                  }}
                  autoComplete={false}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {passwordErr.bool && (
                  <FormHelperText error id="outlined-adornment-error">
                    {passwordErr.value}
                  </FormHelperText>
                )}
              </FormControl>
              <div className="forgtxt">
                <Link to="/forgot-password" className="forgtxt">
                  Forgot Password?
                </Link>
              </div>
              <Button className="frmbtn" type="submit" disabled={load}>
                LOG IN
              </Button>
            </form>
          )}
          <div className="subtxt">
            <span className="subtxt">
              Don't have an account? <Link to="/signup">Create an account</Link>
            </span>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
